var map = {
  "./arrow.svg": "7495",
  "./burger.svg": "3939",
  "./chevron.svg": "8421",
  "./clock.svg": "5462",
  "./close.svg": "8688",
  "./example.svg": "4046",
  "./minus.svg": "1124",
  "./plus.svg": "7116",
  "./social-facebook.svg": "8390",
  "./social-instagram.svg": "5778",
  "./social-linkedin.svg": "9652",
  "./social-tiktok.svg": "4036",
  "./social-youtube.svg": "2985",
  "./star-half.svg": "5130",
  "./star.svg": "2452",
  "./text-highlight.svg": "7530"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 8995;
